module.exports = __webpack_public_path__ + "img/avatar4.c9fe01d0.png";